<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <!-- <div slot="header" class="clearfix"><b>对账单列表</b></div> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="日期">
          <el-date-picker v-model="formInline.dpurtime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GitPurchaseorderList()" size="medium">查询</el-button>
          </Debounce>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border style="width: 100%" max-height="560" highlight-current-row :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="ccheck" label="确认状态" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.ccheck">
              <el-tag type="success" size="small" v-if="scope.row.cvencheck=='已确认'">{{scope.row.ccheck}}</el-tag>
              <el-tag type="danger" size="small" v-else effect="dark">{{scope.row.ccheck}}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="ccorpname" label="公司名称" min-width="150"></el-table-column>
        <!-- <el-table-column prop="cvenname" label="供应商名称" min-width="150"></el-table-column> -->
        <el-table-column prop="ccode" label="对账单号" width="120"></el-table-column>
        <el-table-column prop="ddate" label="截止日期" width="100"></el-table-column>
        <!-- <el-table-column prop="ipayment" label="预付款" width="120"></el-table-column> -->
        <el-table-column prop="ipaymentmoney" label="预付款金额" width="120"></el-table-column>
        <el-table-column prop="izgmoney" label="到货待开票" width="100"></el-table-column>
        <el-table-column prop="iapmoney" label="应付账款" width="100"></el-table-column>
        <el-table-column prop="dcheckdate" label="确认日期" width="100"></el-table-column>
        <el-table-column prop="ccheckop" label="确认人" width="160"></el-table-column>
        <el-table-column prop="cremark" label="备注"></el-table-column>
        <el-table-column prop="cvenremark" label="供应商备注"></el-table-column>
        <!-- <el-table-column prop="cmaker" label="制单人" width="150"></el-table-column>
        <el-table-column prop="cfilename" label="附件名称" width="100"></el-table-column>
      <el-table-column prop="cfilepath" label="附件路径" width="100"></el-table-column> 
        <el-table-column prop="cfiletype" label="附件类型" width="100"></el-table-column>
        <el-table-column prop="cispush" label="是否推送" width="100"></el-table-column>
 
        <el-table-column prop="dreturndate" label="回传日期" width="100"></el-table-column>
        <el-table-column prop="cpushname" label="推送人" width="100"></el-table-column> -->
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="supedit(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pull-right" style="padding:20px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      formInline: {
        dpurtime: "",
      },
      // 分页
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    if (this.$route.query.informdata) {
      if (this.$route.query.informdata.dpurtime != undefined) {
        this.formInline = {};
        this.formInline = this.$route.query.informdata;
      }
    }
    this.GitPurchaseorderList();
  },
  methods: {
    // 获取信息

    GitPurchaseorderList() {
      this.informdatanew = JSON.parse(JSON.stringify(this.formInline));
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetStatementList",
        data: {
          dpurtime: this.formInline.dpurtime,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res, "获取信息结果");
        if (res.data.Success) {
          // this.tableData = res.data.Data;
          this.tableData = res.data.Data.rows;
          this.totalCount = res.data.Data.totalCount;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 确认
    supedit(row) {
      this.$router.push({
        name: "AccountStatement",
        params: { rows: row, informdata: this.informdatanew },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GitPurchaseorderList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GitPurchaseorderList();
    },
  },
};
</script>
<style scoped>
.inputwidth {
  width: 30%;
}
.inputwidth .el-input__inner {
  border: 0;
}
</style>
